import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({})
export default class ScoreInputBase extends Vue {
  @Prop() public value!: number;
  @Prop() public whiteMode!: boolean;
  @Prop({ default: true }) public showNumbers!: boolean;
  @Prop({ default: 5, type: Number }) public max!: number;
  @Prop({ default: 1, type: Number }) public min!: number;
  @Prop({ default: () => ['', '', '', '', '', '', '', ''] }) public labels!: string[];
  @Prop() public descriptions!: string[];
  @Prop() public empty!: string;
  @Prop({ default: false }) public showDescriptions!: boolean;
  @Prop({ default: false }) public showLabels!: boolean;

  @Prop({ default: false })
  public isWidget: boolean;

  @Prop({ default: '' })
  public accessibleLabel!: string;

  public get scores(): number[] {
    const scores = [];
    for (let i = this.min; i <= this.max; i++) scores.push(i);
    return scores;
  }

  public getLabel(score: number): string | number {
    if (this.showLabels && this.labels) return this.$t(this.labels[score]) as string;
    else return this.scores[score - this.min].toString();
  }

  public check(score: number) {
    this.$emit('input', score);
  }
}
